var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "title is-4" }, [_vm._v("General Settings")]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label", attrs: { for: "meeting-name" } }, [
        _vm._v("Meeting Name")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "help" }, [
        _vm._v(
          "\n      You can change the meeting name from its original MatrixMaxx meeting\n      name here. Note that the changes will immediately show for all users.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newMeetingName,
              expression: "newMeetingName"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", name: "meeting-name", id: "meeting-name" },
          domProps: { value: _vm.newMeetingName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newMeetingName = $event.target.value
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c(
        "label",
        { staticClass: "label", attrs: { for: "meeting-timezone" } },
        [_vm._v("Meeting Timezone")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "help" }, [
        _vm._v(
          "\n      The timezone will show on the schedule and user suites pages and will be\n      used for calendar exports. Meetings with no setting here are assumed to\n      be Eastern time.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "select" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newMeetingTimezone,
                expression: "newMeetingTimezone"
              }
            ],
            attrs: { name: "meeting-timezone", id: "meeting-timezone" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.newMeetingTimezone = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("Select a timezone")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "US/Eastern" } }, [
              _vm._v("Eastern")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "US/Central" } }, [
              _vm._v("Central")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "US/Mountain" } }, [
              _vm._v("Mountain")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "US/Pacific" } }, [
              _vm._v("Pacific")
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.updateStatus
      ? _c("p", { staticClass: "mb-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.updateStatus))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button is-success",
        class: { "is-loading": _vm.loading },
        on: {
          click: function($event) {
            return _vm.updateSettings()
          }
        }
      },
      [_vm._v("\n    Save\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-106ae6ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106ae6ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/meeting/MeetingSettings.vue
// module id = null
// module chunks = 